// Generated file, changes will eventually be overwritten!
import { Talent } from './types';

const talents = {
  ABOMINATION_LIMB_TALENT: {
    id: 1263569,
    name: 'Abomination Limb',
    icon: 'ability_maldraxxus_deathknight',
    maxRanks: 1,
    entryIds: [136213],
    definitionIds: [{ id: 140986, specId: 250 }],
  },
  ALL_WILL_SERVE_TALENT: {
    id: 194916,
    name: 'All Will Serve',
    icon: 'ability_fiegndead',
    maxRanks: 1,
    entryIds: [96317],
    definitionIds: [{ id: 101319, specId: 252 }],
  },
  ANCIENT_POWER_TALENT: {
    id: 377590,
    name: 'Ancient Power',
    icon: 'inv_relics_runestone',
    maxRanks: 2,
    entryIds: [96286],
    definitionIds: [{ id: 101288, specId: 252 }],
  },
  ANTI_MAGIC_BARRIER_TALENT: {
    id: 205727,
    name: 'Anti-Magic Barrier',
    icon: 'spell_shadow_antimagicshell',
    maxRanks: 1,
    entryIds: [96174],
    definitionIds: [{ id: 101176, specId: 252 }],
  },
  ANTI_MAGIC_ZONE_TALENT: {
    id: 51052,
    name: 'Anti-Magic Zone',
    icon: 'spell_deathknight_antimagiczone',
    maxRanks: 1,
    entryIds: [96194],
    definitionIds: [{ id: 101196, specId: 252 }],
  },
  APOCALYPSE_NOW_TALENT: {
    id: 444040,
    name: 'Apocalypse Now',
    icon: 'inv_ability_rideroftheapocalypsedeathknight_apocalypsenow',
    maxRanks: 1,
    entryIds: [117638],
    definitionIds: [{ id: 122650, specId: 252 }],
  },
  ARCTIC_ASSAULT_TALENT: {
    id: 456230,
    name: 'Arctic Assault',
    icon: 'artifactability_frostmage_blackicicles',
    maxRanks: 1,
    entryIds: [96248],
    definitionIds: [{ id: 101250, specId: 251 }],
  },
  ARMY_OF_THE_DEAD_TALENT: {
    id: 42650,
    name: 'Army of the Dead',
    icon: 'spell_deathknight_armyofthedead',
    maxRanks: 1,
    entryIds: [96333],
    definitionIds: [{ id: 101335, specId: 252 }],
    runesCost: 1,
    runicPowerCost: -10,
  },
  ASPHYXIATE_TALENT: {
    id: 221562,
    name: 'Asphyxiate',
    icon: 'ability_deathknight_asphixiate',
    maxRanks: 1,
    entryIds: [96193],
    definitionIds: [{ id: 101195, specId: 252 }],
  },
  ASSIMILATION_TALENT: {
    id: 374383,
    name: 'Assimilation',
    icon: 'spell_deathknight_antimagiczone',
    maxRanks: 1,
    entryIds: [96176],
    definitionIds: [{ id: 101178, specId: 252 }],
  },
  AVALANCHE_TALENT: {
    id: 207142,
    name: 'Avalanche',
    icon: 'spell_frost_icestorm',
    maxRanks: 1,
    entryIds: [96235],
    definitionIds: [{ id: 101237, specId: 251 }],
  },
  A_FEAST_OF_SOULS_TALENT: {
    id: 444072,
    name: 'A Feast of Souls',
    icon: 'inv_misc_supersoulash',
    maxRanks: 1,
    entryIds: [123411],
    definitionIds: [{ id: 128249, specId: 252 }],
  },
  BIND_IN_DARKNESS_TALENT: {
    id: 440031,
    name: 'Bind in Darkness',
    icon: 'ability_argus_soulbombdebuffsmall',
    maxRanks: 1,
    entryIds: [117640],
    definitionIds: [{ id: 122652, specId: 251 }],
  },
  BITING_COLD_TALENT: {
    id: 377056,
    name: 'Biting Cold',
    icon: 'ability_deathknight_remorselesswinters2',
    maxRanks: 1,
    entryIds: [96242],
    definitionIds: [{ id: 101244, specId: 251 }],
  },
  BLIGHTBURST_TALENT: {
    id: 1254552,
    name: 'Blightburst',
    icon: 'spell_shadow_unstableaffliction_3_purple',
    maxRanks: 1,
    entryIds: [133515],
    definitionIds: [{ id: 138301, specId: 252 }],
  },
  BLIGHTFALL_TALENT: {
    id: 1271974,
    name: 'Blightfall',
    icon: 'inv_nullstone_shadow',
    maxRanks: 1,
    entryIds: [133513],
    definitionIds: [{ id: 138299, specId: 252 }],
  },
  BLINDING_SLEET_TALENT: {
    id: 207167,
    name: 'Blinding Sleet',
    icon: 'spell_frost_chillingblast',
    maxRanks: 1,
    entryIds: [96172],
    definitionIds: [{ id: 101174, specId: 252 }],
  },
  BLOODIED_BLADE_TALENT: {
    id: 458753,
    name: 'Bloodied Blade',
    icon: 'inv_sword_2h_ebonblade_b_01_red',
    maxRanks: 1,
    entryIds: [126296],
    definitionIds: [{ id: 131122, specId: 250 }],
  },
  BLOODSHOT_TALENT: {
    id: 391398,
    name: 'Bloodshot',
    icon: 'ability_warlock_baneofhavoc',
    maxRanks: 1,
    entryIds: [96256],
    definitionIds: [{ id: 101258, specId: 250 }],
  },
  BLOODWORMS_TALENT: {
    id: 195679,
    name: 'Bloodworms',
    icon: 'spell_shadow_soulleech',
    maxRanks: 1,
    entryIds: [96280],
    definitionIds: [{ id: 101282, specId: 250 }],
  },
  BLOODY_FORTITUDE_TALENT: {
    id: 434136,
    name: 'Bloody Fortitude',
    icon: 'ability_warrior_intensifyrage',
    maxRanks: 1,
    entryIds: [117891],
    definitionIds: [{ id: 122903, specId: 252 }],
  },
  BLOODY_REFLECTION_TALENT: {
    id: 1279633,
    name: 'Bloody Reflection',
    icon: 'ability_warrior_bloodbath',
    maxRanks: 1,
    entryIds: [96271],
    definitionIds: [{ id: 101273, specId: 250 }],
  },
  BLOOD_BOIL_TALENT: {
    id: 50842,
    name: 'Blood Boil',
    icon: 'spell_deathknight_bloodboil',
    maxRanks: 1,
    entryIds: [96305],
    definitionIds: [{ id: 101307, specId: 250 }],
  },
  BLOOD_BOND_TALENT: {
    id: 1267028,
    name: 'Blood Bond',
    icon: 'ability_deathknight_roilingblood',
    maxRanks: 1,
    entryIds: [96189],
    definitionIds: [{ id: 101191, specId: 252 }],
  },
  BLOOD_DRAW_TALENT: {
    id: 374598,
    name: 'Blood Draw',
    icon: 'inv_artifact_bloodoftheassassinated',
    maxRanks: 1,
    entryIds: [96184],
    definitionIds: [{ id: 101186, specId: 252 }],
  },
  BLOOD_FEAST_TALENT: {
    id: 391386,
    name: 'Blood Feast',
    icon: 'spell_deathknight_vendetta',
    maxRanks: 1,
    entryIds: [96309],
    definitionIds: [{ id: 101311, specId: 250 }],
  },
  BLOOD_MIST_TALENT: {
    id: 1263743,
    name: 'Blood Mist',
    icon: 'ability_revendreth_deathknight',
    maxRanks: 1,
    entryIds: [96259],
    definitionIds: [{ id: 101261, specId: 250 }],
  },
  BLOOD_SCENT_TALENT: {
    id: 374030,
    name: 'Blood Scent',
    icon: 'ability_ironmaidens_bloodritual',
    maxRanks: 1,
    entryIds: [96207],
    definitionIds: [{ id: 101209, specId: 252 }],
  },
  BLOOD_SOAKED_GROUND_TALENT: {
    id: 434033,
    name: 'Blood-Soaked Ground',
    icon: 'ability_ironmaidens_corruptedblood',
    maxRanks: 1,
    entryIds: [117645],
    definitionIds: [{ id: 122657, specId: 252 }],
  },
  BOILING_POINT_TALENT: {
    id: 1265790,
    name: 'Boiling Point',
    icon: 'warlock_pvp_endlessaffliction',
    maxRanks: 1,
    entryIds: [96167],
    definitionIds: [{ id: 101169, specId: 250 }],
  },
  BONEGRINDER_TALENT: {
    id: 377098,
    name: 'Bonegrinder',
    icon: 'ability_deathknight_bonegrinder',
    maxRanks: 2,
    entryIds: [96253],
    definitionIds: [{ id: 101255, specId: 251 }],
  },
  BONE_COLLECTOR_TALENT: {
    id: 458572,
    name: 'Bone Collector',
    icon: 'ability_deathknight_boneshield',
    maxRanks: 1,
    entryIds: [96306],
    definitionIds: [{ id: 101308, specId: 250 }],
  },
  BREATH_OF_SINDRAGOSA_TALENT: {
    id: 1249658,
    name: 'Breath of Sindragosa',
    icon: 'spell_deathknight_breathofsindragosa',
    maxRanks: 1,
    entryIds: [96222],
    definitionIds: [{ id: 101224, specId: 251 }],
    runicPowerCost: 60,
  },
  BRITTLE_TALENT: {
    id: 374504,
    name: 'Brittle',
    icon: 'ability_bosskilrogg_deaththroes',
    maxRanks: 1,
    entryIds: [96190],
    definitionIds: [{ id: 101192, specId: 252 }],
  },
  CARNAGE_TALENT: {
    id: 458752,
    name: 'Carnage',
    icon: 'sha_ability_warrior_bloodnova_nightmare',
    maxRanks: 1,
    entryIds: [126301],
    definitionIds: [{ id: 131127, specId: 250 }],
  },
  CHOSEN_OF_FROSTBROOD_1_FROST_TALENT: {
    id: 1265632,
    name: 'Chosen of Frostbrood',
    icon: 'inv12_apextalent_deathknight_chosenofthefrostbrood',
    maxRanks: 1,
    entryIds: [136968],
    definitionIds: [{ id: 141731, specId: 251 }],
  },
  CHOSEN_OF_FROSTBROOD_2_FROST_TALENT: {
    id: 1265633,
    name: 'Chosen of Frostbrood',
    icon: 'achievement_reputation_wyrmresttemple',
    maxRanks: 2,
    entryIds: [136967],
    definitionIds: [{ id: 141730, specId: 251 }],
  },
  CHOSEN_OF_FROSTBROOD_3_FROST_TALENT: {
    id: 1265637,
    name: 'Chosen of Frostbrood',
    icon: 'achievement_reputation_wyrmresttemple',
    maxRanks: 1,
    entryIds: [136966],
    definitionIds: [{ id: 141729, specId: 251 }],
  },
  CLAWING_SHADOWS_TALENT: {
    id: 1241567,
    name: 'Clawing Shadows',
    icon: 'warlock_curse_shadow',
    maxRanks: 1,
    entryIds: [133523],
    definitionIds: [{ id: 138309, specId: 252 }],
  },
  CLEAVING_STRIKES_TALENT: {
    id: 316916,
    name: 'Cleaving Strikes',
    icon: 'inv_1115_warrior_fastermeleeattacks',
    maxRanks: 1,
    entryIds: [96202],
    definitionIds: [{ id: 101204, specId: 252 }],
  },
  COAGULOPATHY_TALENT: {
    id: 391477,
    name: 'Coagulopathy',
    icon: 'ability_skeer_bloodletting',
    maxRanks: 1,
    entryIds: [96169],
    definitionIds: [{ id: 101171, specId: 250 }],
  },
  COIL_OF_DEVASTATION_TALENT: {
    id: 390270,
    name: 'Coil of Devastation',
    icon: 'ability_malkorok_blightofyshaarj_green',
    maxRanks: 1,
    entryIds: [96290],
    definitionIds: [{ id: 101292, specId: 252 }],
  },
  COLDTHIRST_TALENT: {
    id: 378848,
    name: 'Coldthirst',
    icon: 'spell_deathknight_mindfreeze',
    maxRanks: 1,
    entryIds: [96212],
    definitionIds: [{ id: 101214, specId: 252 }],
  },
  COMMANDER_OF_THE_DEAD_TALENT: {
    id: 390259,
    name: 'Commander of the Dead',
    icon: 'spell_shadow_fumble',
    maxRanks: 2,
    entryIds: [96283],
    definitionIds: [{ id: 101285, specId: 252 }],
  },
  CONSUMPTION_TALENT: {
    id: 1263824,
    name: 'Consumption',
    icon: 'inv_axe_2h_artifactmaw_d_01',
    maxRanks: 1,
    entryIds: [126300],
    definitionIds: [{ id: 131125, specId: 250 }],
  },
  CONTROL_UNDEAD_TALENT: {
    id: 111673,
    name: 'Control Undead',
    icon: 'inv_misc_bone_skull_01',
    maxRanks: 1,
    entryIds: [96188],
    definitionIds: [{ id: 101190, specId: 252 }],
    runesCost: 1,
    runicPowerCost: -10,
  },
  CRYOGENIC_CHAMBER_TALENT: {
    id: 456237,
    name: 'Cryogenic Chamber',
    icon: 'spell_fire_bluecano',
    maxRanks: 1,
    entryIds: [131618],
    definitionIds: [{ id: 136419, specId: 251 }],
  },
  CYCLE_OF_DEATH_TALENT: {
    id: 1290864,
    name: 'Cycle of Death',
    icon: 'ability_ironmaidens_whirlofblood',
    maxRanks: 1,
    entryIds: [96289],
    definitionIds: [{ id: 101291, specId: 252 }],
  },
  DANCE_OF_MIDNIGHT_1_BLOOD_TALENT: {
    id: 1264506,
    name: 'Dance of Midnight',
    icon: 'inv12_apextalent_deathknight_danceofmidnight',
    maxRanks: 1,
    entryIds: [136917],
    definitionIds: [{ id: 141680, specId: 250 }],
  },
  DANCE_OF_MIDNIGHT_2_BLOOD_TALENT: {
    id: 1264405,
    name: 'Dance of Midnight',
    icon: 'ability_demonhunter_bladedance',
    maxRanks: 2,
    entryIds: [136916],
    definitionIds: [{ id: 141679, specId: 250 }],
  },
  DANCE_OF_MIDNIGHT_3_BLOOD_TALENT: {
    id: 1264351,
    name: 'Dance of Midnight',
    icon: 'ability_demonhunter_bladedance',
    maxRanks: 1,
    entryIds: [136915],
    definitionIds: [{ id: 141678, specId: 250 }],
  },
  DANCING_RUNE_WEAPON_TALENT: {
    id: 49028,
    name: 'Dancing Rune Weapon',
    icon: 'inv_sword_07',
    maxRanks: 1,
    entryIds: [96269],
    definitionIds: [{ id: 101271, specId: 250 }],
  },
  DARK_TALONS_TALENT: {
    id: 436687,
    name: 'Dark Talons',
    icon: 'inv_shoulder_93',
    maxRanks: 1,
    entryIds: [117654],
    definitionIds: [{ id: 122666, specId: 251 }],
  },
  DARK_TRANSFORMATION_TALENT: {
    id: 1233448,
    name: 'Dark Transformation',
    icon: 'achievement_boss_festergutrotface',
    maxRanks: 1,
    entryIds: [96322],
    definitionIds: [{ id: 101324, specId: 252 }],
  },
  DEADLY_REACH_TALENT: {
    id: 1264235,
    name: 'Deadly Reach',
    icon: 'inv12_ability_deathknight_cleavingdeathstrikes',
    maxRanks: 1,
    entryIds: [96301],
    definitionIds: [{ id: 101303, specId: 250 }],
  },
  DEATHLY_BLOWS_TALENT: {
    id: 1265932,
    name: 'Deathly Blows',
    icon: 'inv_sword_1h_mawraid_d_02',
    maxRanks: 1,
    entryIds: [135992],
    definitionIds: [{ id: 140747, specId: 251 }],
  },
  DEATHS_ECHO_TALENT: {
    id: 356367,
    name: "Death's Echo",
    icon: 'inv_fabric_ebonweave',
    maxRanks: 1,
    entryIds: [126015],
    definitionIds: [{ id: 130846, specId: 252 }],
  },
  DEATHS_MESSENGER_TALENT: {
    id: 437122,
    name: "Death's Messenger",
    icon: 'ability_argus_deathfog',
    maxRanks: 1,
    entryIds: [117646],
    definitionIds: [{ id: 122658, specId: 251 }],
  },
  DEATHS_REACH_TALENT: {
    id: 276079,
    name: "Death's Reach",
    icon: 'spell_deathknight_strangulate',
    maxRanks: 1,
    entryIds: [136526],
    definitionIds: [{ id: 141299, specId: 252 }],
  },
  DEATH_CHARGE_TALENT: {
    id: 444010,
    name: 'Death Charge',
    icon: 'ability_mount_steelwarhorse',
    maxRanks: 1,
    entryIds: [123412],
    definitionIds: [{ id: 128250, specId: 252 }],
  },
  DEATH_DEFIANCE_TALENT: {
    id: 1266818,
    name: 'Death Defiance',
    icon: 'spell_nature_shamanrage',
    maxRanks: 1,
    entryIds: [136525],
    definitionIds: [{ id: 141298, specId: 252 }],
  },
  DEATH_NOTES_TALENT: {
    id: 1266819,
    name: 'Death Notes',
    icon: 'inv_misc_book_01',
    maxRanks: 1,
    entryIds: [136524],
    definitionIds: [{ id: 141297, specId: 252 }],
  },
  DEATH_PACT_TALENT: {
    id: 48743,
    name: 'Death Pact',
    icon: 'spell_shadow_deathpact',
    maxRanks: 1,
    entryIds: [96204],
    definitionIds: [{ id: 101206, specId: 252 }],
  },
  DEATH_STRIKE_TALENT: {
    id: 49998,
    name: 'Death Strike',
    icon: 'spell_deathknight_butcher2',
    maxRanks: 1,
    entryIds: [96200],
    definitionIds: [{ id: 101202, specId: 252 }],
    runicPowerCost: 45,
  },
  DESECRATE_TALENT: {
    id: 1234559,
    name: 'Desecrate',
    icon: 'sha_ability_rogue_bloodyeye_nightmare',
    maxRanks: 1,
    entryIds: [136836],
    definitionIds: [{ id: 141599, specId: 252 }],
  },
  DOOMED_BIDDING_TALENT: {
    id: 455386,
    name: 'Doomed Bidding',
    icon: 'ability_deathknight_shatteringbone',
    maxRanks: 1,
    entryIds: [125816],
    definitionIds: [{ id: 130648, specId: 252 }],
  },
  EBON_FEVER_TALENT: {
    id: 207269,
    name: 'Ebon Fever',
    icon: 'spell_shadow_creepingplague',
    maxRanks: 1,
    entryIds: [96334],
    definitionIds: [{ id: 101336, specId: 252 }],
  },
  ECHOING_FURY_TALENT: {
    id: 1265855,
    name: 'Echoing Fury',
    icon: 'spell_fire_blueflamebreath',
    maxRanks: 1,
    entryIds: [135991],
    definitionIds: [{ id: 140746, specId: 251 }],
  },
  EMPOWER_RUNE_WEAPON_TALENT: {
    id: 47568,
    name: 'Empower Rune Weapon',
    icon: 'inv_sword_62',
    maxRanks: 1,
    entryIds: [96225],
    definitionIds: [{ id: 101227, specId: 251 }],
  },
  ENDURING_STRENGTH_TALENT: {
    id: 377190,
    name: 'Enduring Strength',
    icon: 'spell_shadow_soulleech_2',
    maxRanks: 1,
    entryIds: [125875],
    definitionIds: [{ id: 130706, specId: 251 }],
  },
  ENFEEBLE_TALENT: {
    id: 392566,
    name: 'Enfeeble',
    icon: 'ability_creature_poison_01',
    maxRanks: 1,
    entryIds: [136523],
    definitionIds: [{ id: 141296, specId: 252 }],
  },
  EVERFROST_TALENT: {
    id: 376938,
    name: 'Everfrost',
    icon: 'ability_mage_deepfreeze',
    maxRanks: 1,
    entryIds: [96229],
    definitionIds: [{ id: 101231, specId: 251 }],
  },
  EVERLASTING_BOND_TALENT: {
    id: 377668,
    name: 'Everlasting Bond',
    icon: 'inv_sword_07',
    maxRanks: 1,
    entryIds: [96261],
    definitionIds: [{ id: 101263, specId: 250 }],
  },
  EXPELLING_SHIELD_TALENT: {
    id: 439948,
    name: 'Expelling Shield',
    icon: 'spell_shadow_antimagicshell',
    maxRanks: 1,
    entryIds: [128234],
    definitionIds: [{ id: 133041, specId: 251 }],
  },
  EXTERMINATE_TALENT: {
    id: 441378,
    name: 'Exterminate',
    icon: 'inv_polearm_2h_titanargus_d_01',
    maxRanks: 1,
    entryIds: [117665],
    definitionIds: [{ id: 122677, specId: 251 }],
  },
  FESTERING_SCYTHE_TALENT: {
    id: 455397,
    name: 'Festering Scythe',
    icon: 'inv_polearm_2h_mawnecromancerboss_d_01_darkblue',
    maxRanks: 1,
    entryIds: [96330],
    definitionIds: [{ id: 101332, specId: 252 }],
  },
  FORBIDDEN_KNOWLEDGE_1_UNHOLY_TALENT: {
    id: 1242158,
    name: 'Forbidden Knowledge',
    icon: 'inv12_apextalent_deathknight_forbiddenknowledge',
    maxRanks: 1,
    entryIds: [136920],
    definitionIds: [{ id: 141683, specId: 252 }],
  },
  FORBIDDEN_KNOWLEDGE_2_UNHOLY_TALENT: {
    id: 1256565,
    name: 'Forbidden Knowledge',
    icon: 'spell_shadow_fingerofdeath',
    maxRanks: 2,
    entryIds: [136919],
    definitionIds: [{ id: 141682, specId: 252 }],
  },
  FORBIDDEN_KNOWLEDGE_3_UNHOLY_TALENT: {
    id: 1256566,
    name: 'Forbidden Knowledge',
    icon: 'inv12_apextalent_deathknight_forbiddenknowledge',
    maxRanks: 1,
    entryIds: [136918],
    definitionIds: [{ id: 141681, specId: 252 }],
  },
  FOUL_BULWARK_TALENT: {
    id: 206974,
    name: 'Foul Bulwark',
    icon: 'inv_armor_shield_naxxramas_d_02',
    maxRanks: 1,
    entryIds: [96302],
    definitionIds: [{ id: 101304, specId: 250 }],
  },
  FOUL_INFECTIONS_TALENT: {
    id: 455396,
    name: 'Foul Infections',
    icon: 'spell_holy_nullifydisease',
    maxRanks: 1,
    entryIds: [96296],
    definitionIds: [{ id: 101298, specId: 252 }],
  },
  FRENZIED_BLOODTHIRST_TALENT: {
    id: 434075,
    name: 'Frenzied Bloodthirst',
    icon: 'inv_sulfurelemental_blood',
    maxRanks: 1,
    entryIds: [117662],
    definitionIds: [{ id: 122674, specId: 252 }],
  },
  FRIGID_EXECUTIONER_TALENT: {
    id: 377073,
    name: 'Frigid Executioner',
    icon: 'spell_shadow_focusedpower',
    maxRanks: 1,
    entryIds: [96221],
    definitionIds: [{ id: 101223, specId: 251 }],
  },
  FRIGID_RESOLVE_TALENT: {
    id: 1265859,
    name: 'Frigid Resolve',
    icon: 'spell_deathknight_icetouch',
    maxRanks: 1,
    entryIds: [135993],
    definitionIds: [{ id: 140748, specId: 251 }],
  },
  FROSTBANE_TALENT: {
    id: 455993,
    name: 'Frostbane',
    icon: 'inv_sword_1h_artifactruneblade_d_02',
    maxRanks: 1,
    entryIds: [96223],
    definitionIds: [{ id: 101225, specId: 251 }],
  },
  FROSTBOUND_WILL_TALENT: {
    id: 1238680,
    name: 'Frostbound Will',
    icon: 'ability_mage_frostjaw',
    maxRanks: 1,
    entryIds: [133362],
    definitionIds: [{ id: 138148, specId: 251 }],
  },
  FROSTREAPER_TALENT: {
    id: 1230301,
    name: 'Frostreaper',
    icon: 'inv_axe_1h_pvpdraenors2_d_02',
    maxRanks: 1,
    entryIds: [96228],
    definitionIds: [{ id: 101230, specId: 251 }],
  },
  FROSTSCYTHE_TALENT: {
    id: 207230,
    name: 'Frostscythe',
    icon: 'inv12_ability_deathknight_frostscythe',
    maxRanks: 1,
    entryIds: [96243],
    definitionIds: [{ id: 101245, specId: 251 }],
    runesCost: 2,
  },
  FROSTWYRMS_FURY_TALENT: {
    id: 279302,
    name: "Frostwyrm's Fury",
    icon: 'achievement_boss_sindragosa',
    maxRanks: 1,
    entryIds: [96236],
    definitionIds: [{ id: 101238, specId: 251 }],
  },
  FROST_STRIKE_TALENT: {
    id: 49143,
    name: 'Frost Strike',
    icon: 'spell_deathknight_empowerruneblade2',
    maxRanks: 1,
    entryIds: [96245],
    definitionIds: [{ id: 101247, specId: 251 }],
    runicPowerCost: 35,
  },
  FROZEN_DOMINION_TALENT: {
    id: 377226,
    name: 'Frozen Dominion',
    icon: 'spell_fire_bluehellfire',
    maxRanks: 1,
    entryIds: [126017],
    definitionIds: [{ id: 130848, specId: 251 }],
  },
  FURY_OF_THE_HORSEMEN_TALENT: {
    id: 444069,
    name: 'Fury of the Horsemen',
    icon: 'inv_plate_raiddeathknightmythic_o_01helm',
    maxRanks: 1,
    entryIds: [117639],
    definitionIds: [{ id: 122651, specId: 252 }],
  },
  GATHERING_STORM_TALENT: {
    id: 194912,
    name: 'Gathering Storm',
    icon: 'spell_frost_ice_shards',
    maxRanks: 1,
    entryIds: [96240],
    definitionIds: [{ id: 101242, specId: 251 }],
  },
  GHOULISH_FRENZY_TALENT: {
    id: 377587,
    name: 'Ghoulish Frenzy',
    icon: 'ability_warlock_baneofhavoc',
    maxRanks: 1,
    entryIds: [96331],
    definitionIds: [{ id: 101333, specId: 252 }],
  },
  GIFT_OF_THE_SANLAYN_TALENT: {
    id: 434152,
    name: "Gift of the San'layn",
    icon: 'spell_deathknight_bloodtap',
    maxRanks: 1,
    entryIds: [117650],
    definitionIds: [{ id: 122662, specId: 252 }],
  },
  GLOOM_WARD_TALENT: {
    id: 391571,
    name: 'Gloom Ward',
    icon: 'ability_rogue_envelopingshadows',
    maxRanks: 2,
    entryIds: [96180],
    definitionIds: [{ id: 101182, specId: 252 }],
  },
  GOREFIENDS_GRASP_TALENT: {
    id: 108199,
    name: "Gorefiend's Grasp",
    icon: 'ability_deathknight_aoedeathgrip',
    maxRanks: 1,
    entryIds: [96170],
    definitionIds: [{ id: 101172, specId: 250 }],
  },
  GRAVE_MASTERY_TALENT: {
    id: 1238900,
    name: 'Grave Mastery',
    icon: 'achievement_dungeon_plaguefall_stradamamargrave',
    maxRanks: 1,
    entryIds: [133365],
    definitionIds: [{ id: 138151, specId: 252 }],
  },
  GRIM_REAPER_TALENT: {
    id: 434905,
    name: 'Grim Reaper',
    icon: 'spell_misc_zandalari_council_soulswap',
    maxRanks: 1,
    entryIds: [117631],
    definitionIds: [{ id: 122643, specId: 251 }],
  },
  GRIP_OF_THE_DEAD_TALENT: {
    id: 273952,
    name: 'Grip of the Dead',
    icon: 'ability_creature_disease_05',
    maxRanks: 1,
    entryIds: [96186],
    definitionIds: [{ id: 101188, specId: 252 }],
  },
  HARBINGER_OF_DOOM_TALENT: {
    id: 276023,
    name: 'Harbinger of Doom',
    icon: 'inv_mawguardpet_black',
    maxRanks: 1,
    entryIds: [96313],
    definitionIds: [{ id: 101315, specId: 252 }],
  },
  HEARTBREAKER_TALENT: {
    id: 221536,
    name: 'Heartbreaker',
    icon: 'spell_deathknight_deathstrike',
    maxRanks: 1,
    entryIds: [96266],
    definitionIds: [{ id: 101268, specId: 250 }],
  },
  HEART_STRIKE_TALENT: {
    id: 206930,
    name: 'Heart Strike',
    icon: 'inv_weapon_shortblade_40',
    maxRanks: 1,
    entryIds: [96304],
    definitionIds: [{ id: 101306, specId: 250 }],
    runesCost: 1,
    runicPowerCost: -15,
  },
  HEMOSTASIS_TALENT: {
    id: 273946,
    name: 'Hemostasis',
    icon: 'ability_deathwing_bloodcorruption_earth',
    maxRanks: 1,
    entryIds: [96268],
    definitionIds: [{ id: 101270, specId: 250 }],
  },
  HORSEMENS_AID_TALENT: {
    id: 444074,
    name: "Horsemen's Aid",
    icon: 'achievement_dungeon_nexusraid_10man',
    maxRanks: 1,
    entryIds: [117634],
    definitionIds: [{ id: 122646, specId: 252 }],
  },
  HOWLING_BLADES_TALENT: {
    id: 1230223,
    name: 'Howling Blades',
    icon: 'inv_10_specialization_blacksmithing_blades_color2',
    maxRanks: 1,
    entryIds: [96165],
    definitionIds: [{ id: 101167, specId: 251 }],
  },
  HOWLING_BLAST_TALENT: {
    id: 49184,
    name: 'Howling Blast',
    icon: 'spell_frost_arcticwinds',
    maxRanks: 1,
    entryIds: [96244],
    definitionIds: [{ id: 101246, specId: 251 }],
    runesCost: 1,
    runicPowerCost: -10,
  },
  HUNGERING_THIRST_TALENT: {
    id: 444037,
    name: 'Hungering Thirst',
    icon: 'spell_shadow_fumble',
    maxRanks: 1,
    entryIds: [117641],
    definitionIds: [{ id: 122653, specId: 252 }],
  },
  HYPERPYREXIA_TALENT: {
    id: 456238,
    name: 'Hyperpyrexia',
    icon: 'spell_fire_bluefire',
    maxRanks: 1,
    entryIds: [96238],
    definitionIds: [{ id: 101240, specId: 251 }],
  },
  ICEBOUND_FORTITUDE_TALENT: {
    id: 48792,
    name: 'Icebound Fortitude',
    icon: 'spell_deathknight_iceboundfortitude',
    maxRanks: 1,
    entryIds: [96210],
    definitionIds: [{ id: 101212, specId: 252 }],
  },
  ICEBREAKER_TALENT: {
    id: 392950,
    name: 'Icebreaker',
    icon: 'ability_mage_icewall',
    maxRanks: 2,
    entryIds: [96161],
    definitionIds: [{ id: 101163, specId: 251 }],
  },
  ICE_PRISON_TALENT: {
    id: 454786,
    name: 'Ice Prison',
    icon: 'ability_mage_deepfreeze',
    maxRanks: 1,
    entryIds: [96215],
    definitionIds: [{ id: 101217, specId: 252 }],
  },
  ICY_DEATH_TORRENT_TALENT: {
    id: 435010,
    name: 'Icy Death Torrent',
    icon: 'ability_argus_soulburst',
    maxRanks: 1,
    entryIds: [125878],
    definitionIds: [{ id: 130709, specId: 251 }],
  },
  ICY_ONSLAUGHT_TALENT: {
    id: 1230272,
    name: 'Icy Onslaught',
    icon: 'ability_deathknight_chillstreak',
    maxRanks: 1,
    entryIds: [131619],
    definitionIds: [{ id: 136420, specId: 251 }],
  },
  ICY_TALONS_TALENT: {
    id: 194878,
    name: 'Icy Talons',
    icon: 'spell_deathknight_icytalons',
    maxRanks: 1,
    entryIds: [96214],
    definitionIds: [{ id: 101216, specId: 252 }],
  },
  IMPROVED_BONE_SHIELD_TALENT: {
    id: 374715,
    name: 'Improved Bone Shield',
    icon: 'ability_deathknight_marrowrend',
    maxRanks: 1,
    entryIds: [96274],
    definitionIds: [{ id: 101276, specId: 250 }],
  },
  IMPROVED_DEATH_STRIKE_TALENT: {
    id: 374277,
    name: 'Improved Death Strike',
    icon: 'spell_deathknight_butcher2',
    maxRanks: 1,
    entryIds: [96196],
    definitionIds: [{ id: 101198, specId: 252 }],
  },
  IMPROVED_HEART_STRIKE_TALENT: {
    id: 374717,
    name: 'Improved Heart Strike',
    icon: 'inv_weapon_shortblade_40',
    maxRanks: 2,
    entryIds: [96257],
    definitionIds: [{ id: 101259, specId: 250 }],
  },
  IMPROVED_VAMPIRIC_BLOOD_TALENT: {
    id: 317133,
    name: 'Improved Vampiric Blood',
    icon: 'spell_shadow_lifedrain',
    maxRanks: 2,
    entryIds: [96272],
    definitionIds: [{ id: 101274, specId: 250 }],
  },
  INCITE_TERROR_TALENT: {
    id: 434151,
    name: 'Incite Terror',
    icon: 'ability_warlock_improveddemonictactics',
    maxRanks: 1,
    entryIds: [117637],
    definitionIds: [{ id: 122649, specId: 252 }],
  },
  INEVITABLE_TALENT: {
    id: 1280658,
    name: 'Inevitable',
    icon: 'spell_warlock_demonsoul',
    maxRanks: 1,
    entryIds: [117642],
    definitionIds: [{ id: 122654, specId: 252 }],
  },
  INEXORABLE_ASSAULT_TALENT: {
    id: 253593,
    name: 'Inexorable Assault',
    icon: 'achievement_dungeon_icecrown_frostmourne',
    maxRanks: 1,
    entryIds: [96230],
    definitionIds: [{ id: 101232, specId: 251 }],
  },
  INFECTED_CLAWS_TALENT: {
    id: 207272,
    name: 'Infected Claws',
    icon: 'ability_creature_disease_05',
    maxRanks: 1,
    entryIds: [96324],
    definitionIds: [{ id: 101326, specId: 252 }],
  },
  INFLICTION_OF_SORROW_TALENT: {
    id: 434143,
    name: 'Infliction of Sorrow',
    icon: 'ability_warrior_bloodbath',
    maxRanks: 1,
    entryIds: [117630],
    definitionIds: [{ id: 122642, specId: 252 }],
  },
  INSATIABLE_BLADE_TALENT: {
    id: 377637,
    name: 'Insatiable Blade',
    icon: '70_inscription_vantus_rune_nightmare',
    maxRanks: 1,
    entryIds: [96260],
    definitionIds: [{ id: 101262, specId: 250 }],
  },
  INSIDIOUS_CHILL_TALENT: {
    id: 391566,
    name: 'Insidious Chill',
    icon: 'ability_racial_wardoftheloafrost',
    maxRanks: 1,
    entryIds: [96179],
    definitionIds: [{ id: 101181, specId: 252 }],
  },
  IRON_HEART_TALENT: {
    id: 391395,
    name: 'Iron Heart',
    icon: 'inv_ragnaros_heart',
    maxRanks: 1,
    entryIds: [96307],
    definitionIds: [{ id: 101309, specId: 250 }],
  },
  KILLING_MACHINE_TALENT: {
    id: 51128,
    name: 'Killing Machine',
    icon: 'inv_sword_122',
    maxRanks: 1,
    entryIds: [96247],
    definitionIds: [{ id: 101249, specId: 251 }],
  },
  KILLING_STREAK_TALENT: {
    id: 1230153,
    name: 'Killing Streak',
    icon: 'ability_creature_cursed_05',
    maxRanks: 1,
    entryIds: [96254],
    definitionIds: [{ id: 101256, specId: 251 }],
  },
  LEECHING_STRIKE_TALENT: {
    id: 377629,
    name: 'Leeching Strike',
    icon: 'ability_deathwing_bloodcorruption_death',
    maxRanks: 1,
    entryIds: [96278],
    definitionIds: [{ id: 101280, specId: 250 }],
  },
  LET_TERROR_REIGN_TALENT: {
    id: 1265949,
    name: 'Let Terror Reign',
    icon: 'spell_deathknight_plaguestrike',
    maxRanks: 1,
    entryIds: [135998],
    definitionIds: [{ id: 140753, specId: 252 }],
  },
  LIFEBLOOD_TALENT: {
    id: 1264296,
    name: 'Lifeblood',
    icon: 'inv_10_elementalcombinedfoozles_blood',
    maxRanks: 1,
    entryIds: [96276],
    definitionIds: [{ id: 101278, specId: 250 }],
  },
  MAGUS_OF_THE_DEAD_TALENT: {
    id: 390196,
    name: 'Magus of the Dead',
    icon: 'ability_maldraxxus_mage',
    maxRanks: 1,
    entryIds: [96282],
    definitionIds: [{ id: 101284, specId: 252 }],
  },
  MARCH_OF_DARKNESS_TALENT: {
    id: 391546,
    name: 'March of Darkness',
    icon: 'ability_argus_deathfog',
    maxRanks: 1,
    entryIds: [96203],
    definitionIds: [{ id: 101205, specId: 252 }],
  },
  MARROWREND_TALENT: {
    id: 195182,
    name: 'Marrowrend',
    icon: 'ability_deathknight_marrowrend',
    maxRanks: 1,
    entryIds: [96303],
    definitionIds: [{ id: 101305, specId: 250 }],
    runesCost: 2,
    runicPowerCost: -20,
  },
  MAWSWORN_MENACE_TALENT: {
    id: 444099,
    name: 'Mawsworn Menace',
    icon: 'inv_mawguardpet_black',
    maxRanks: 1,
    entryIds: [117651],
    definitionIds: [{ id: 122663, specId: 252 }],
  },
  MENACING_MAGUS_TALENT: {
    id: 455135,
    name: 'Menacing Magus',
    icon: 'ability_warlock_coil2',
    maxRanks: 1,
    entryIds: [125815],
    definitionIds: [{ id: 130647, specId: 252 }],
  },
  MIND_FREEZE_TALENT: {
    id: 47528,
    name: 'Mind Freeze',
    icon: 'spell_deathknight_mindfreeze',
    maxRanks: 1,
    entryIds: [96213],
    definitionIds: [{ id: 101215, specId: 252 }],
  },
  MOGRAINES_MIGHT_TALENT: {
    id: 444047,
    name: "Mograine's Might",
    icon: 'ability_warlock_improvedsoulleech',
    maxRanks: 1,
    entryIds: [117664],
    definitionIds: [{ id: 122676, specId: 252 }],
  },
  MORBIDITY_TALENT: {
    id: 377592,
    name: 'Morbidity',
    icon: 'spell_necro_deathlyecho',
    maxRanks: 1,
    entryIds: [96294],
    definitionIds: [{ id: 101296, specId: 252 }],
  },
  MURDEROUS_EFFICIENCY_TALENT: {
    id: 207061,
    name: 'Murderous Efficiency',
    icon: 'spell_frost_frostarmor',
    maxRanks: 1,
    entryIds: [96252],
    definitionIds: [{ id: 101254, specId: 251 }],
  },
  NAZGRIMS_CONQUEST_TALENT: {
    id: 444052,
    name: "Nazgrim's Conquest",
    icon: 'ability_maldraxxus_warriorplantbanner',
    maxRanks: 1,
    entryIds: [117656],
    definitionIds: [{ id: 122668, specId: 252 }],
  },
  NECROMANCERS_CUNNING_TALENT: {
    id: 288848,
    name: "Necromancer's Cunning",
    icon: 'artifactability_unholydeathknight_deathsembrace',
    maxRanks: 1,
    entryIds: [136797],
    definitionIds: [{ id: 141560, specId: 252 }],
  },
  NEWLY_TURNED_TALENT: {
    id: 433934,
    name: 'Newly Turned',
    icon: 'ability_deathknight_hemorrhagicfever',
    maxRanks: 1,
    entryIds: [117661],
    definitionIds: [{ id: 122673, specId: 252 }],
  },
  NORTHWINDS_TALENT: {
    id: 1230284,
    name: 'Northwinds',
    icon: 'ability_mage_freeze',
    maxRanks: 1,
    entryIds: [96239],
    definitionIds: [{ id: 101241, specId: 251 }],
  },
  NULL_MAGIC_TALENT: {
    id: 454842,
    name: 'Null Magic',
    icon: 'spell_shadow_detectinvisibility',
    maxRanks: 1,
    entryIds: [126016],
    definitionIds: [{ id: 130847, specId: 252 }],
  },
  OBLITERATE_TALENT: {
    id: 49020,
    name: 'Obliterate',
    icon: 'spell_deathknight_classicon',
    maxRanks: 1,
    entryIds: [96246],
    definitionIds: [{ id: 101248, specId: 251 }],
    runesCost: 2,
  },
  OBLITERATION_TALENT: {
    id: 281238,
    name: 'Obliteration',
    icon: 'inv_axe_114',
    maxRanks: 1,
    entryIds: [96220],
    definitionIds: [{ id: 101222, specId: 251 }],
  },
  ON_A_PALER_HORSE_TALENT: {
    id: 444008,
    name: 'On a Paler Horse',
    icon: 'inv_skeletalwarhorse_01_purple',
    maxRanks: 1,
    entryIds: [117657],
    definitionIds: [{ id: 122669, specId: 252 }],
  },
  OSMOSIS_TALENT: {
    id: 454835,
    name: 'Osmosis',
    icon: 'spell_nature_rune',
    maxRanks: 1,
    entryIds: [96217],
    definitionIds: [{ id: 101219, specId: 252 }],
  },
  OSSUARY_TALENT: {
    id: 219786,
    name: 'Ossuary',
    icon: 'ability_deathknight_brittlebones',
    maxRanks: 1,
    entryIds: [96277],
    definitionIds: [{ id: 101279, specId: 250 }],
  },
  OUTBREAK_TALENT: {
    id: 77575,
    name: 'Outbreak',
    icon: 'spell_deathvortex',
    maxRanks: 1,
    entryIds: [96326],
    definitionIds: [{ id: 101328, specId: 252 }],
    runesCost: 1,
    runicPowerCost: -10,
  },
  OUTNUMBER_TALENT: {
    id: 1241705,
    name: 'Outnumber',
    icon: 'spell_shadow_darksummoning',
    maxRanks: 1,
    entryIds: [96318],
    definitionIds: [{ id: 101320, specId: 252 }],
  },
  PACT_OF_THE_APOCALYPSE_TALENT: {
    id: 444083,
    name: 'Pact of the Apocalypse',
    icon: 'achievement_dungeon_nexus80_25man',
    maxRanks: 1,
    entryIds: [123410],
    definitionIds: [{ id: 128248, specId: 252 }],
  },
  PACT_OF_THE_DEATHBRINGER_TALENT: {
    id: 440476,
    name: 'Pact of the Deathbringer',
    icon: 'ability_revendreth_deathknight',
    maxRanks: 1,
    entryIds: [117632],
    definitionIds: [{ id: 122644, specId: 251 }],
  },
  PACT_OF_THE_SANLAYN_TALENT: {
    id: 434261,
    name: "Pact of the San'layn",
    icon: 'ability_warrior_bloodnova',
    maxRanks: 1,
    entryIds: [117652],
    definitionIds: [{ id: 122664, specId: 252 }],
  },
  PERMAFROST_TALENT: {
    id: 207200,
    name: 'Permafrost',
    icon: 'achievement_zone_frostfire',
    maxRanks: 1,
    entryIds: [96195],
    definitionIds: [{ id: 101197, specId: 252 }],
  },
  PERSEVERANCE_OF_THE_EBON_BLADE_TALENT: {
    id: 374747,
    name: 'Perseverance of the Ebon Blade',
    icon: 'ability_deathknight_sanguinfortitude',
    maxRanks: 1,
    entryIds: [96255],
    definitionIds: [{ id: 101257, specId: 250 }],
  },
  PILLAR_OF_FROST_TALENT: {
    id: 51271,
    name: 'Pillar of Frost',
    icon: 'ability_deathknight_pillaroffrost',
    maxRanks: 1,
    entryIds: [125874],
    definitionIds: [{ id: 130705, specId: 251 }],
  },
  PLAGUE_INFUSION_TALENT: {
    id: 1265869,
    name: 'Plague Infusion',
    icon: 'spell_yorsahj_bloodboil_blue',
    maxRanks: 1,
    entryIds: [126298],
    definitionIds: [{ id: 131124, specId: 250 }],
  },
  PLAGUE_MASTERY_TALENT: {
    id: 390166,
    name: 'Plague Mastery',
    icon: 'spell_shadow_blackplague',
    maxRanks: 1,
    entryIds: [96323],
    definitionIds: [{ id: 101325, specId: 252 }],
  },
  PROLIFERATING_CHILL_TALENT: {
    id: 373930,
    name: 'Proliferating Chill',
    icon: 'spell_frost_chainsofice',
    maxRanks: 1,
    entryIds: [125606],
    definitionIds: [{ id: 130438, specId: 252 }],
  },
  PURGATORY_TALENT: {
    id: 114556,
    name: 'Purgatory',
    icon: 'inv_misc_shadowegg',
    maxRanks: 1,
    entryIds: [96264],
    definitionIds: [{ id: 101266, specId: 250 }],
  },
  PUTREFY_TALENT: {
    id: 1247378,
    name: 'Putrefy',
    icon: 'inv12_ability_deathknight_putrefy',
    maxRanks: 1,
    entryIds: [133522],
    definitionIds: [{ id: 138308, specId: 252 }],
    runicPowerCost: -10,
    runesCost: 1,
  },
  PUTRID_ECHOES_TALENT: {
    id: 377580,
    name: 'Putrid Echoes',
    icon: 'inv12_ability_deathknight_dreadplague',
    maxRanks: 1,
    entryIds: [133546],
    definitionIds: [{ id: 138332, specId: 252 }],
  },
  RAGE_OF_THE_FROZEN_CHAMPION_TALENT: {
    id: 377076,
    name: 'Rage of the Frozen Champion',
    icon: 'spell_mage_frostbomb',
    maxRanks: 1,
    entryIds: [125876],
    definitionIds: [{ id: 130707, specId: 251 }],
  },
  RAISE_ABOMINATION_TALENT: {
    id: 1242608,
    name: 'Raise Abomination',
    icon: 'achievement_boss_patchwerk',
    maxRanks: 1,
    entryIds: [96311],
    definitionIds: [{ id: 101313, specId: 252 }],
  },
  RAISE_DEAD_TALENT: {
    id: 46585,
    name: 'Raise Dead',
    icon: 'inv_pet_ghoul',
    maxRanks: 1,
    entryIds: [96201],
    definitionIds: [{ id: 101203, specId: 252 }],
  },
  RAPID_DECOMPOSITION_TALENT: {
    id: 194662,
    name: 'Rapid Decomposition',
    icon: 'ability_deathknight_deathsiphon2',
    maxRanks: 1,
    entryIds: [96273],
    definitionIds: [{ id: 101275, specId: 250 }],
  },
  REANIMATION_TALENT: {
    id: 1256813,
    name: 'Reanimation',
    icon: 'achievement_dungeon_thenecroticwake_amarth',
    maxRanks: 1,
    entryIds: [135676],
    definitionIds: [{ id: 140432, specId: 252 }],
  },
  REAPERS_MARK_TALENT: {
    id: 439843,
    name: "Reaper's Mark",
    icon: 'inv_ability_deathbringerdeathknight_reapersmark',
    maxRanks: 1,
    entryIds: [117659],
    definitionIds: [{ id: 122671, specId: 251 }],
    runesCost: 2,
  },
  REAPERS_ONSLAUGHT_TALENT: {
    id: 469870,
    name: "Reaper's Onslaught",
    icon: 'ability_demonhunter_soulcleave2',
    maxRanks: 1,
    entryIds: [128266],
    definitionIds: [{ id: 133073, specId: 251 }],
  },
  REAPING_TALENT: {
    id: 377514,
    name: 'Reaping',
    icon: 'ability_deathwing_bloodcorruption_death',
    maxRanks: 1,
    entryIds: [133517],
    definitionIds: [{ id: 138303, specId: 252 }],
  },
  RED_THIRST_TALENT: {
    id: 205723,
    name: 'Red Thirst',
    icon: 'spell_deathknight_bloodpresence',
    maxRanks: 1,
    entryIds: [96263],
    definitionIds: [{ id: 101265, specId: 250 }],
  },
  RELISH_IN_BLOOD_TALENT: {
    id: 317610,
    name: 'Relish in Blood',
    icon: 'ability_deathknight_roilingblood',
    maxRanks: 1,
    entryIds: [96279],
    definitionIds: [{ id: 101281, specId: 250 }],
  },
  RIDERS_CHAMPION_TALENT: {
    id: 444005,
    name: "Rider's Champion",
    icon: 'achievement_zone_icecrown_01',
    maxRanks: 1,
    entryIds: [117663],
    definitionIds: [{ id: 122675, specId: 252 }],
  },
  RIDE_OR_DIE_TALENT: {
    id: 1265959,
    name: 'Ride or Die!',
    icon: 'achievement_boss_fourhorsemen',
    maxRanks: 1,
    entryIds: [135999],
    definitionIds: [{ id: 140754, specId: 252 }],
  },
  RUNE_CARVED_PLATES_TALENT: {
    id: 440282,
    name: 'Rune Carved Plates',
    icon: 'spell_deathknight_runetap',
    maxRanks: 1,
    entryIds: [123420],
    definitionIds: [{ id: 128258, specId: 251 }],
  },
  RUNE_MASTERY_TALENT: {
    id: 374574,
    name: 'Rune Mastery',
    icon: 'ability_deathknight_hungeringruneblade',
    maxRanks: 2,
    entryIds: [96208],
    definitionIds: [{ id: 101210, specId: 252 }],
  },
  RUNIC_ATTENUATION_TALENT: {
    id: 207104,
    name: 'Runic Attenuation',
    icon: 'boss_odunrunes_blue',
    maxRanks: 1,
    entryIds: [96173],
    definitionIds: [{ id: 101175, specId: 252 }],
  },
  RUNIC_COMMAND_TALENT: {
    id: 376251,
    name: 'Runic Command',
    icon: 'ability_domination_rune07',
    maxRanks: 2,
    entryIds: [96232],
    definitionIds: [{ id: 101234, specId: 251 }],
  },
  RUNIC_OVERFLOW_TALENT: {
    id: 316803,
    name: 'Runic Overflow',
    icon: 'ability_domination_rune01',
    maxRanks: 2,
    entryIds: [96233],
    definitionIds: [{ id: 101235, specId: 251 }],
  },
  RUNIC_PROTECTION_TALENT: {
    id: 454788,
    name: 'Runic Protection',
    icon: 'ability_mage_shattershield',
    maxRanks: 1,
    entryIds: [96183],
    definitionIds: [{ id: 101185, specId: 252 }],
  },
  SANGUINARY_BURST_TALENT: {
    id: 1263781,
    name: 'Sanguinary Burst',
    icon: 'spell_animarevendreth_groundstate',
    maxRanks: 1,
    entryIds: [96258],
    definitionIds: [{ id: 101260, specId: 250 }],
  },
  SANGUINE_GROUND_TALENT: {
    id: 391458,
    name: 'Sanguine Ground',
    icon: 'inv_artifact_corruptedbloodofzakajz',
    maxRanks: 1,
    entryIds: [96262],
    definitionIds: [{ id: 101264, specId: 250 }],
  },
  SANGUINE_SCENT_TALENT: {
    id: 434263,
    name: 'Sanguine Scent',
    icon: 'ability_deathknight_roilingblood',
    maxRanks: 1,
    entryIds: [117893],
    definitionIds: [{ id: 122905, specId: 252 }],
  },
  SCOURGE_STRIKE_TALENT: {
    id: 55090,
    name: 'Scourge Strike',
    icon: 'spell_deathknight_scourgestrike',
    maxRanks: 1,
    entryIds: [96327],
    definitionIds: [{ id: 101329, specId: 252 }],
    runesCost: 1,
    runicPowerCost: -10,
  },
  SCOURGING_TALENT: {
    id: 1242604,
    name: 'Scourging',
    icon: 'spell_deathknight_deathstrike',
    maxRanks: 2,
    entryIds: [133516],
    definitionIds: [{ id: 138302, specId: 252 }],
  },
  SHATTERING_BLADE_TALENT: {
    id: 207057,
    name: 'Shattering Blade',
    icon: 'inv_7af_deathknight_frostmournefragment',
    maxRanks: 1,
    entryIds: [96224],
    definitionIds: [{ id: 101226, specId: 251 }],
  },
  SMOTHERING_OFFENSE_TALENT: {
    id: 435005,
    name: 'Smothering Offense',
    icon: 'inv_10_specialreagentfoozles_tuskclaw_ice',
    maxRanks: 1,
    entryIds: [96231],
    definitionIds: [{ id: 101233, specId: 251 }],
  },
  SOUL_REAPER_TALENT: {
    id: 343294,
    name: 'Soul Reaper',
    icon: 'ability_deathknight_soulreaper',
    maxRanks: 1,
    entryIds: [96314],
    definitionIds: [{ id: 101316, specId: 252 }],
    runesCost: 1,
    runicPowerCost: -10,
  },
  SOUL_RUPTURE_TALENT: {
    id: 437161,
    name: 'Soul Rupture',
    icon: 'warlock_siphonlife',
    maxRanks: 1,
    entryIds: [117658],
    definitionIds: [{ id: 122670, specId: 251 }],
  },
  SUBDUING_GRASP_TALENT: {
    id: 454822,
    name: 'Subduing Grasp',
    icon: 'spell_nature_elementalshields',
    maxRanks: 1,
    entryIds: [96209],
    definitionIds: [{ id: 101211, specId: 252 }],
  },
  SUDDEN_DOOM_TALENT: {
    id: 49530,
    name: 'Sudden Doom',
    icon: 'spell_shadow_painspike',
    maxRanks: 1,
    entryIds: [96328],
    definitionIds: [{ id: 101330, specId: 252 }],
  },
  SUMMON_GARGOYLE_TALENT: {
    id: 1242147,
    name: 'Summon Gargoyle',
    icon: 'ability_deathknight_summongargoyle',
    maxRanks: 1,
    entryIds: [133514],
    definitionIds: [{ id: 138300, specId: 252 }],
  },
  SUPERSTRAIN_TALENT: {
    id: 390283,
    name: 'Superstrain',
    icon: 'spell_deathknight_explode_ghoul',
    maxRanks: 1,
    entryIds: [96329],
    definitionIds: [{ id: 101331, specId: 252 }],
  },
  SUPPRESSION_TALENT: {
    id: 374049,
    name: 'Suppression',
    icon: 'ability_racial_forceshield',
    maxRanks: 1,
    entryIds: [96216],
    definitionIds: [{ id: 101218, specId: 252 }],
  },
  SWIFT_AND_PAINFUL_TALENT: {
    id: 443560,
    name: 'Swift and Painful',
    icon: 'ability_domination_rune02',
    maxRanks: 1,
    entryIds: [117629],
    definitionIds: [{ id: 122641, specId: 251 }],
  },
  THE_BLOOD_IS_LIFE_TALENT: {
    id: 434260,
    name: 'The Blood is Life',
    icon: 'achievement_nazmir_boss_bloodofghuun',
    maxRanks: 1,
    entryIds: [117643],
    definitionIds: [{ id: 122655, specId: 252 }],
  },
  THE_LONG_WINTER_TALENT: {
    id: 456240,
    name: 'The Long Winter',
    icon: 'inv_10_dungeonjewelry_primalist_necklace_1_frost',
    maxRanks: 1,
    entryIds: [125877],
    definitionIds: [{ id: 130708, specId: 251 }],
  },
  THRILL_OF_BLOOD_TALENT: {
    id: 1265547,
    name: 'Thrill of Blood',
    icon: 'spell_nzinsanity_bloodthirst',
    maxRanks: 1,
    entryIds: [135995],
    definitionIds: [{ id: 140750, specId: 252 }],
  },
  TRANSFUSION_TALENT: {
    id: 1265574,
    name: 'Transfusion',
    icon: 'inv_artifact_bloodoftheassassinated',
    maxRanks: 1,
    entryIds: [135994],
    definitionIds: [{ id: 140749, specId: 252 }],
  },
  TROLLBANES_ICY_FURY_TALENT: {
    id: 444097,
    name: "Trollbane's Icy Fury",
    icon: 'ability_warrior_shatteringthrow',
    maxRanks: 1,
    entryIds: [117660],
    definitionIds: [{ id: 122672, specId: 252 }],
  },
  UMBILICUS_ETERNUS_TALENT: {
    id: 391517,
    name: 'Umbilicus Eternus',
    icon: 'artifactability_blooddeathknight_umbilicuseternus',
    maxRanks: 1,
    entryIds: [96168],
    definitionIds: [{ id: 101170, specId: 250 }],
  },
  UNHOLY_ARMAMENTS_TALENT: {
    id: 1265971,
    name: 'Unholy Armaments',
    icon: 'ability_deathknight_necroticstrike',
    maxRanks: 1,
    entryIds: [135997],
    definitionIds: [{ id: 140752, specId: 252 }],
  },
  UNHOLY_AURA_TALENT: {
    id: 377440,
    name: 'Unholy Aura',
    icon: 'ability_deathknight_decomposingaura',
    maxRanks: 2,
    entryIds: [96284],
    definitionIds: [{ id: 101286, specId: 252 }],
  },
  UNHOLY_BOND_TALENT: {
    id: 374261,
    name: 'Unholy Bond',
    icon: 'inv_sword_1h_felfireraid_d_01',
    maxRanks: 1,
    entryIds: [96205],
    definitionIds: [{ id: 101207, specId: 252 }],
  },
  UNHOLY_DEVOTION_TALENT: {
    id: 1241858,
    name: 'Unholy Devotion',
    icon: 'ability_creature_cursed_03',
    maxRanks: 1,
    entryIds: [96321],
    definitionIds: [{ id: 101323, specId: 252 }],
  },
  UNHOLY_ENDURANCE_TALENT: {
    id: 389682,
    name: 'Unholy Endurance',
    icon: 'spell_deathknight_subversion',
    maxRanks: 1,
    entryIds: [96187],
    definitionIds: [{ id: 101189, specId: 252 }],
  },
  UNHOLY_MOMENTUM_TALENT: {
    id: 374265,
    name: 'Unholy Momentum',
    icon: 'spell_necro_deathrift',
    maxRanks: 2,
    entryIds: [96198],
    definitionIds: [{ id: 101200, specId: 252 }],
  },
  UNYIELDING_WILL_TALENT: {
    id: 457574,
    name: 'Unyielding Will',
    icon: 'spell_shadow_nethercloak',
    maxRanks: 1,
    entryIds: [96178],
    definitionIds: [{ id: 101180, specId: 252 }],
  },
  VAMPIRIC_AURA_TALENT: {
    id: 434100,
    name: 'Vampiric Aura',
    icon: 'ability_rogue_vendetta',
    maxRanks: 1,
    entryIds: [117653],
    definitionIds: [{ id: 122665, specId: 252 }],
  },
  VAMPIRIC_BLOOD_TALENT: {
    id: 55233,
    name: 'Vampiric Blood',
    icon: 'spell_shadow_lifedrain',
    maxRanks: 1,
    entryIds: [96308],
    definitionIds: [{ id: 101310, specId: 250 }],
  },
  VAMPIRIC_SPEED_TALENT: {
    id: 434028,
    name: 'Vampiric Speed',
    icon: 'inv_boots_cloth_34v2',
    maxRanks: 1,
    entryIds: [117892],
    definitionIds: [{ id: 122904, specId: 252 }],
  },
  VAMPIRIC_STRIKE_TALENT: {
    id: 433901,
    name: 'Vampiric Strike',
    icon: 'inv_ability_sanlayndeathknight_vampiricstrike',
    maxRanks: 1,
    entryIds: [117648],
    definitionIds: [{ id: 122660, specId: 252 }],
  },
  VESTIGIAL_SHELL_TALENT: {
    id: 454851,
    name: 'Vestigial Shell',
    icon: 'ability_domination_rune12',
    maxRanks: 1,
    entryIds: [96181],
    definitionIds: [{ id: 101183, specId: 252 }],
  },
  VETERAN_OF_THE_THIRD_WAR_TALENT: {
    id: 48263,
    name: 'Veteran of the Third War',
    icon: 'spell_misc_warsongfocus',
    maxRanks: 1,
    entryIds: [96197],
    definitionIds: [{ id: 101199, specId: 252 }],
  },
  VISCERAL_STRENGTH_TALENT: {
    id: 434157,
    name: 'Visceral Strength',
    icon: 'inv_ragnaros_heart',
    maxRanks: 1,
    entryIds: [135996],
    definitionIds: [{ id: 140751, specId: 252 }],
  },
  VORACIOUS_TALENT: {
    id: 273953,
    name: 'Voracious',
    icon: 'ability_ironmaidens_whirlofblood',
    maxRanks: 1,
    entryIds: [96171],
    definitionIds: [{ id: 101173, specId: 250 }],
  },
  WAVE_OF_SOULS_TALENT: {
    id: 439851,
    name: 'Wave of Souls',
    icon: 'spell_animamaw_wave',
    maxRanks: 1,
    entryIds: [117633],
    definitionIds: [{ id: 122645, specId: 251 }],
  },
  WHITEMANES_FAMINE_TALENT: {
    id: 444033,
    name: "Whitemane's Famine",
    icon: 'spell_deathknight_necroticplague',
    maxRanks: 1,
    entryIds: [117644],
    definitionIds: [{ id: 122656, specId: 252 }],
  },
  WILL_OF_THE_NECROPOLIS_TALENT: {
    id: 206967,
    name: 'Will of the Necropolis',
    icon: 'achievement_boss_kelthuzad_01',
    maxRanks: 2,
    entryIds: [96182],
    definitionIds: [{ id: 101184, specId: 252 }],
  },
  WITHER_AWAY_TALENT: {
    id: 441894,
    name: 'Wither Away',
    icon: 'sha_spell_warlock_demonsoul',
    maxRanks: 1,
    entryIds: [117655],
    definitionIds: [{ id: 122667, specId: 251 }],
  },
  WRAITH_WALK_TALENT: {
    id: 212552,
    name: 'Wraith Walk',
    icon: 'inv_helm_plate_raiddeathknight_p_01',
    maxRanks: 1,
    entryIds: [133518],
    definitionIds: [{ id: 138304, specId: 252 }],
  },
} satisfies Record<string, Talent>;

export default talents;
export { talents as TALENTS_DEATH_KNIGHT };
